import { classes } from "../../../helper";
import Button from "../../Button/Button";
import Icon from "../../Icon/Icon";
import Tooltip from "../../Tooltip/Tooltip";
import { PIN_LIMIT_TOOLTIP } from "./constants";
import styles from "./PinButton.module.css";

type Props = {
  active: boolean;
  siteName: string;
  onToggle: () => void;
  disabled?: boolean;
};

function PinButton({ active, siteName, onToggle, disabled = false }: Props) {
  const button = (
    <Button
      type="button"
      variant="transparent"
      disabled={disabled}
      className={classes(
        styles.pinButton,
        active ? styles.pinButtonActive : "",
        disabled ? styles.pinButtonDisabled : ""
      )}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!disabled) onToggle();
      }}
      aria-label={active ? `Unpin ${siteName}` : `Pin ${siteName}`}
      title={disabled ? undefined : active ? "Unpin site" : "Pin site"}
    >
      <Icon name={active ? "Unpin" : "Pin"} className={styles.pinIcon} />
    </Button>
  );

  return (
    <Tooltip
      content={PIN_LIMIT_TOOLTIP}
      placement="bottom"
      disabled={!disabled}
    >
      {button}
    </Tooltip>
  );
}

export default PinButton;
